import { gql } from "@apollo/client";

// 사장님: 내가 제출한 의견 목록만
export const GET_MY_BOSS_FEEDBACK_POSTS = gql(`
  query GetMyBossFeedbackPosts {
    myBossFeedbackPosts {
      id
      content
      authorName
      authorId
      status
      createdAt
      updatedAt
      replyCount
      replies {
        id
        content
        isAdmin
        createdAt
      }
    }
  }
`);

// 단건 조회 (사장님은 본인 글만, 어드민은 전체)
export const GET_BOSS_FEEDBACK_POST = gql(`
  query GetBossFeedbackPost($id: ID!) {
    bossFeedbackPost(id: $id) {
      id
      content
      authorName
      authorId
      status
      createdAt
      updatedAt
      replyCount
      replies {
        id
        content
        isAdmin
        createdAt
        updatedAt
      }
    }
  }
`);

// 게시글 제출
export const CREATE_BOSS_FEEDBACK_POST = gql(`
  mutation CreateBossFeedbackPost($input: CreateBossFeedbackPostInput!) {
    createBossFeedbackPost(input: $input) {
      id
      content
      authorName
      authorId
      status
      createdAt
      replyCount
    }
  }
`);

// 어드민: 전체 목록
export const GET_BOSS_FEEDBACK_POSTS = gql(`
  query GetBossFeedbackPosts($offset: Int!, $limit: Int!) {
    bossFeedbackPosts(offset: $offset, limit: $limit) {
      id
      content
      authorName
      authorId
      status
      createdAt
      updatedAt
      replyCount
      replies {
        id
        content
        isAdmin
        createdAt
      }
    }
  }
`);

// 어드민: 답변 작성
export const CREATE_BOSS_FEEDBACK_REPLY = gql(`
  mutation CreateBossFeedbackReply($input: CreateBossFeedbackReplyInput!) {
    createBossFeedbackReply(input: $input) {
      id
      content
      isAdmin
      createdAt
      post {
        id
        status
        replyCount
      }
    }
  }
`);

// 어드민: 게시글 삭제
export const DELETE_BOSS_FEEDBACK_POST = gql(`
  mutation DeleteBossFeedbackPost($id: Int!) {
    deleteBossFeedbackPost(id: $id) {
      ok
      error
    }
  }
`);
